var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('editor',{attrs:{"api-key":"9e86e9z0v1z8b8x78wypdpc0cpimqkeux1950hb6n6paecfg","init":{
    schema: 'html5',
    menubar: false, // Enable menubar for better UI
    branding: false,
    plugins: [
      'advlist autolink autosave autoresize link image lists charmap hr anchor',
      'searchreplace wordcount visualblocks visualchars code fullscreen insertdatetime nonbreaking',
      'table template colorpicker paste textcolor importcss textpattern spellchecker',
      'fontsizeselect',
      'forecolor',
      'backcolor',
      'code',
      'image' // Ensure image plugin is included
    ],
    toolbar: [
      'undo redo | bold italic underline strikethrough | alignleft aligncenter alignright | blockquote | formatselect',
      'bullist numlist | outdent indent | hr | link unlink image code | inserttime',
      'table | fontsizeselect | forecolor | backcolor'
    ],
    fontsize_formats: '8px 10px 12px 14px 16px 18px 24px 36px 48pt 72px',
    content_style: 'body { font-size: 14px; }',
    automatic_uploads: true,
    images_upload_url: 'http://localhost:3000/upload', // Your backend endpoint
    images_upload_base_path: '/uploads',
    file_picker_types: 'image',
    images_upload_handler: _vm.imageUpload
    
  }},model:{value:(_vm.localHighlights),callback:function ($$v) {_vm.localHighlights=$$v},expression:"localHighlights"}})}
var staticRenderFns = []

export { render, staticRenderFns }